import React, { useEffect, useState } from 'react'
import Confetti from 'react-confetti'

export default () => {
  const  height = window.innerHeight
  const  width = window.innerWidth
  const [recycle,setRecycle] = useState(true)

  useEffect(()=>{
setTimeout(()=>{
  setRecycle(false)
},6000)
  },[])
  
  return (
        <Confetti width={width} height={height} recycle={recycle} numberOfPieces={200} style={{zIndex:"1100"}}  />
    
  )
}